import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import './Users.scss';
import toast, { Toaster } from 'react-hot-toast';
import UserDetails from './UserDetails';
import ConfirmDeleteUser from './ConfirmDeleteUser'
import './Users.scss';
import ZeusTable2 from 'components/tables/ZeusTable2.tsx'
import CreateUserForm from './CreateUserForm';
import { intermediatePageArray, RowActions, ShowRole, ShowDate, ShowStatus } from 'components/tables/tableTools'

import { createColumnHelper } from '@tanstack/react-table'

const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});



export default function Users() {

  const [showUserDetails, setShowUserDetails] = useState(false)
  const [showDeleteUser, setShowDeleteUser] = useState(false)
  const [showCreateUserForm, setShowCreateUserForm] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState()
  const [iteration, setIteration] = useState(0)

  // Table data
  const [data, setData] = React.useState({})

  async function getUsersData() {
    try {
      const resUsers = await API.post("/admin/users");
      setData(resUsers.data);
    } catch (error) {
      console.log(error?.response?.data);
      toast.error(error?.response?.data)
    }
  }
  useEffect(() => {
    getUsersData()
  }, [iteration])

  const createUser = async (profile) => {
    try {
      const resUser = await API.post("/admin/users/create", profile);
      toast.success("User saved")
      getUsersData()
      return resUser.data;
    } catch (error) {
      console.log(error?.response?.data);
      toast.error(error?.response?.data)
      return error?.response?.data;
    }
  };

  const removeUser = async (id) => {
    try {
      const resUser = await API.post("/admin/users/delete", {id: id});
      toast.success("User removed")
      getUsersData()
      return resUser.data;
    } catch (error) {
      console.log(error?.response?.data);
      toast.error(error?.response?.data)
      return error?.response?.data;
    }
  };

  const columnHelper = createColumnHelper()
  const columns = [
    columnHelper.display({
      id: 'Actions',
      cell: info => <RowActions id={info.row.original.id} function1={editUser} function2={confirmDeleteUser} />,
    }),
    columnHelper.accessor(row => `${row.first_name} ${row.last_name}`, {
      id: 'Name',
      header: () => <span>Name</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.last_name, {
      id: 'Last Name',
      cell: info => info.getValue(),
      header: () => <span>Last Name</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.email, {
      id: 'Email',
      cell: info => info.getValue(),
      header: () => <span>Email</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.company, {
      id: 'Company',
      cell: info => <i>{info.getValue()}</i>,
      header: () => <span>Company</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.company_id, {
      id: 'Company ID',
      cell: info => <i>{info.getValue()}</i>,
      header: () => <span>Company ID</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.country, {
      id: 'Country',
      header: () => <span>Country</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.status, {
      id: 'Status',
      header: () => <span>Status</span>,
      cell: props => <ShowStatus row={props.row} />,
      meta: {
        className: 'd-none d-md-table-cell',
      },
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.email_verified_at, {
      id: 'Verification Date',
      header: () => <span>Verification Date</span>,
      cell: props => <ShowDate row={props.row.original.email_verified_at} />,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.registration_date_time, {
      id: 'Registration Date',
      header: () => <span>Registration Date</span>,
      cell: props => <ShowDate row={props.row.original.registration_date_time} />,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.super_user, {
      id: 'Role',
      header: () => <span>Role</span>,
      cell: props => <ShowRole row={props.row} />,
      footer: info => info.column.id,
    })
  ]
  
  const editUser = (childData) => {
      document.body.classList.add('modal-open');
      setSelectedUserId(childData)
      setShowUserDetails(true)
  };
  const openCreateUserForm = () => {
    document.body.classList.add('modal-open');
    setShowCreateUserForm(true)
  };
  const addUser = (childData) => {
    console.log(childData)
    setShowCreateUserForm(false)
    const result = createUser(childData)
  }
  const saveUserDetails = (childData) => {
    console.log("Saving data", childData)
  }
  const closeModal = () => {
    setShowUserDetails(false)
    document.body.classList.remove('modal-open');
    setIteration(1 + iteration)
  }
  const confirmDeleteUser = (childData) => {
    setSelectedUserId(childData)
    console.log(childData)
    setShowDeleteUser(true)
    console.log("please confirm deletion of", childData);
  };

  const cancelDeleteUser = () => {
    setShowDeleteUser(false)
    closeModal()
  }
  const cancelAddUser = () => {
    setShowCreateUserForm(false)
    closeModal()
  }
  const deleteUser = () => {
    setShowDeleteUser(false)
    closeModal()
    console.log("Send command to backend to delete user", selectedUserId);
    removeUser(selectedUserId)
  }

    return (
      <div>
        <div>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
        </div>
        <div className="header pb-6">
          <div className="container-fluid">
            <div className="header-body">
              <div className="row align-items-center py-4">
                <div className="col-lg-6 col-7">
                  <h2 className="h2 d-inline-block mb-0">Users</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid mt--6" style={{minHeight: '100vh'}}>
          <div className="card">
            <ZeusTable2
              columns={columns}
              data={data}
              create={openCreateUserForm}
              createLabel="Add New User"
              refreshData={getUsersData}
            />

          </div>
          { showUserDetails &&
            <UserDetails userId={selectedUserId} closeForm={closeModal} saveUserDetails={saveUserDetails}/> 
          }
          { showDeleteUser &&
            <ConfirmDeleteUser userId={selectedUserId} cancel={cancelDeleteUser} confirm={deleteUser}/> 
          }
          { showCreateUserForm &&
            <CreateUserForm cancel={cancelAddUser} confirm={addUser}/> 
          }
        </div>
      </div>
    );
}